import script from "./ReadModels.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadModels.vue?vue&type=script&setup=true&lang=js"

import "./ReadModels.vue?vue&type=style&index=0&id=a1f0e526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1f0e526"]])

export default __exports__